export const GET_SUMMERCAMP_EVENTS = "GET_SUMMERCAMP_EVENTS"
export const REGISTER_SUMMERCAMP_EVENTS = "REGISTER_SUMMERCAMP_EVENTS"
